import { useState } from 'react'
import { ChevronDownIcon, ChevronRightIcon } from 'lucide-react'
import DocumentRow from './DocumentRow';

export default function DocumentSection({ title, documents }) {
  const [open, setOpen] = useState(false)

  return (
    <div className='w-full border border-gray-100 dark:border-slate-700/50 dark:border-slate-700 rounded-2xl bg-white dark:bg-slate-800 shadow-sm overflow-hidden transition-colors duration-300 mb-4'>
      <button onClick={() => setOpen(!open)} className='flex items-center justify-between w-full px-6 py-4 bg-white dark:bg-slate-800 hover:bg-gray-50 dark:hover:bg-slate-900 dark:hover:bg-slate-700/50 transition-colors text-left text-sm font-semibold text-gray-800 dark:text-gray-200 dark:text-gray-100 focus:outline-none'>
        <div className='flex items-center gap-3'>
          <span className='w-7 h-7 rounded-full bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 flex items-center justify-center font-bold text-xs shadow-sm transition-colors'>
            {documents.length}
          </span>
          <span className='font-bold uppercase tracking-wider text-[13px]'>{title}</span>
        </div>
        <div className={`transition-transform duration-300 ${open ? 'rotate-180' : 'rotate-0'}`}>
          <ChevronDownIcon className='h-5 w-5 text-gray-400 dark:text-gray-500 dark:text-slate-500 transition-colors' />
        </div>
      </button>

      <div className={`grid transition-[grid-template-rows,opacity] duration-300 ease-in-out ${open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
        <div className='overflow-hidden'>
          <div className='w-full flex flex-col gap-3 p-4 bg-slate-50 dark:bg-slate-900/50 border-t border-gray-100/60 dark:border-slate-700/50 shadow-inner transition-colors duration-300'>
            {documents.length === 0 ? (
              <p className='text-sm text-gray-500 dark:text-gray-400 dark:text-slate-400 py-4 text-center italic transition-colors'>No documents.</p>
            ) : (
              documents.map(doc => (
                <DocumentRow
                  key={doc.documentId}
                  _document={doc}
                />
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
